// modules
import dayjs from 'dayjs';
import FormatService from 'modules/Format';

export const getSelectedExpiry = (
  expiries: number[],
  selectedExpiry: number,
  isCommodity: boolean,
) => {
  if (isCommodity) {
    const selectedExpiryMonth = dayjs(selectedExpiry).month() + 1;
    const expiryDate = expiries.find(expiry => {
      const expiryMonth = dayjs(expiry).month() + 1;
      return expiryMonth === selectedExpiryMonth;
    });
    return expiryDate || expiries[0];
  }
  return selectedExpiry;
};

export const getSpotLiveDataLtp = (ltp?: string, close?: string) => {
  if (ltp && ltp !== '0') {
    return ltp;
  }
  if (close && close !== '0') {
    return close;
  }
  return '';
};

export const getDaysLeftToExpiry = (selectedExpiry: number) => {
  if (!selectedExpiry) return '--';
  const currentDate = new Date();
  const targetDate = new Date(selectedExpiry);
  const diffInMilliseconds = targetDate.getTime() - currentDate.getTime();
  return Math.max(Math.ceil(diffInMilliseconds / (1000 * 60 * 60 * 24)), 0);
};

export const getLtpAndLtpChange = (
  lastTraded?: string,
  close?: string,
  showPercent = true,
  exchangeToken?: string,
) => {
  const { ltpChange, value } = FormatService.getLtpChange(
    lastTraded,
    close,
    showPercent,
    exchangeToken,
  );
  const formattedLtp = lastTraded ? FormatService.formatToIndianFloat(lastTraded) : '';

  return {
    value,
    ltpChange,
    formattedLtp,
  };
};

export const getSpotPrice = (
  lastTradedPrice?: string,
  close?: string,
): number | null => {
  const spotClose = close ? Number(close) : null;
  const ltp = lastTradedPrice ? Number(lastTradedPrice) : null;
  const spotPrice = ltp === 0 ? spotClose : ltp;
  return spotPrice;
};
